import { Card, Row, Col, Statistic, Progress, Tag, Tooltip, Button } from 'antd';
import {
  UserOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  SyncOutlined,
  EyeOutlined,
  StarOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';

export default function SegmentStats({ segment }) {
  const isDefaultSegment = segment.type === 'default';
  
  const stats = {
    userCount: segment.userCount || 0,
    lastUpdated: segment.lastEvaluatedAt 
      ? new Date(segment.lastEvaluatedAt).toLocaleString()
      : 'Never',
    accuracy: isDefaultSegment ? 'Dynamic' : 'Static',
  };

  const getDefaultSegmentIcon = () => {
    switch(segment.defaultCategory) {
      case 'engagement': return <EyeOutlined />;
      case 'interaction': return <CheckCircleOutlined />;
      case 'subscription': return <UserOutlined />;
      case 'status': return <ClockCircleOutlined />;
      default: return <StarOutlined />;
    }
  };

  return (
    <div style={{ padding: '16px 0' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card size="small">
            <Statistic
              title="Total Users"
              value={stats.userCount}
              prefix={<UserOutlined />}
              suffix={isDefaultSegment ? 'dynamic' : ''}
            />
            {isDefaultSegment && (
              <div style={{ marginTop: 8 }}>
                <small className="text-muted">
                  <SyncOutlined /> Updates automatically
                </small>
              </div>
            )}
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card size="small">
            <Statistic
              title="Segment Type"
              value={segment.type === 'default' ? 'System' : 'Custom'}
              prefix={isDefaultSegment ? getDefaultSegmentIcon() : <UserOutlined />}
            />
            {isDefaultSegment && segment.defaultCategory && (
              <Tag color="blue" style={{ marginTop: 8 }}>
                {segment.defaultCategory}
              </Tag>
            )}
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card size="small">
            <Statistic
              title="Last Updated"
              value={stats.lastUpdated}
              prefix={<CalendarOutlined />}
            />
            {isDefaultSegment && !segment.lastEvaluatedAt && (
              <div style={{ marginTop: 8 }}>
                <small className="text-warning">
                  Needs refresh
                </small>
              </div>
            )}
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card size="small">
            <Statistic
              title="Rules"
              value={segment.rules?.length || 0}
              suffix={isDefaultSegment ? 'dynamic' : 'static'}
            />
            {isDefaultSegment && (
              <div style={{ marginTop: 8 }}>
                <small className="text-muted">
                  Based on user behavior
                </small>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      
      {isDefaultSegment && (
        <div style={{ marginTop: 16, padding: 12, background: '#f6ffed', borderRadius: 8 }}>
          <div className="d-flex align-items-center">
            <StarOutlined style={{ color: '#52c41a', marginRight: 8 }} />
            <div>
              <strong>System Segment</strong>
              <p className="mb-0 small text-muted">
                This segment is automatically maintained by the system based on user engagement metrics.
                User counts update automatically as users interact with your campaigns.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}